import request from '@/libs/request'
export function GET_SCENE_DETAIL (id) {
    return request({
        url: `/scene/detail/${id}`,
        method: 'get',
    })
}